import { Button } from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import {
	ExistList,
	UserAddForm,
	UserEditForm,
} from 'containers/pages/users/components';
import { UserList, UsersSearch } from 'containers/pages/users/components';
import useUsers from './useUsers';
import styles from './Users.module.css';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { useAddUserTourSync } from 'components/onboarding/tour/useAddUserTourSync';

/**
 * @component Users
 * @returns {JSX.Element}
 */
function Users() {
	const state = useUsers();

	// Drives the "Add a user" walkthrough from the page's real state.
	useAddUserTourSync(state.isOpenForm);

	return (
		<main className={styles.main}>
			<header className={styles.header}>
				<Button
					variant="contained"
					color="sds"
					data-tour="new-user-button"
					startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
					onClick={state.onClickForm}
				>
					{state.isAddMode ? 'NEW USER' : 'EDIT USER'}
				</Button>
				<UsersSearch />
			</header>
			{state.isOpenForm &&
				(state.isAddMode ? (
					<div className={styles.form}>
						<UserAddForm
							id={state.selContId}
							onClickForm={state.onClickForm}
							handleMode={state.handleMode}
							userGroups={state.userGroups}
						/>
					</div>
				) : (
					<div className={styles.form}>
						<UserEditForm
							id={state.selUserId}
							handleMode={state.handleMode}
							onClickForm={state.onClickForm}
							userGroups={state.userGroups}
						/>
					</div>
				))}
			{state.existingContacts?.length > 0 && (
				<ExistList contacts={state.existingContacts} />
			)}
			<UserList
				handleMode={state.handleMode}
				userGroups={state.userGroups}
			/>
			<LoadingBackdrop open={state.isLoading} />
		</main>
	);
}

export default Users;
